import { render, staticRenderFns } from "./viewingAgreement.vue?vue&type=template&id=4f5adff8&scoped=true&"
import script from "./viewingAgreement.vue?vue&type=script&lang=js&"
export * from "./viewingAgreement.vue?vue&type=script&lang=js&"
import style0 from "./viewingAgreement.vue?vue&type=style&index=0&id=4f5adff8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5adff8",
  null
  
)

export default component.exports